import {AppActions, NavigationActions, NavigationDirections} from "@ignitesales/neuro-application";

const IMG_ID_MIN = 0;
const IMG_ID_MAX = 8;

const fargoThemeReducer = (state, action) => {
    switch (action.type) {
        case AppActions.APP_READY: {
            return {
                ...state,
                sidebarImageId: 0
            };
        }

        case NavigationActions.PAGE_REQUEST_COMPLETED: {
            const { nextPage, direction } = action;
            const { sidebarImageId  } = state;
            let updatedImageId = sidebarImageId || 0;
            if (nextPage?.type === 'survey') {
                if (direction === NavigationDirections.BACK) {
                    updatedImageId = sidebarImageId > IMG_ID_MIN ? sidebarImageId - 1 : IMG_ID_MAX;
                } else {
                    updatedImageId = sidebarImageId < IMG_ID_MAX ? sidebarImageId + 1 : IMG_ID_MIN;
                }
            }

            return {
                ...state,
                sidebarImageId: updatedImageId
            };
        }

        default:
            return state;
    }
};

export default fargoThemeReducer;
